/**
 * @file 缓存数据 读写
 * @author svon.me@gmail.com
 **/

import * as AES from "./aes";
import * as _ from "lodash-es";
import safeGet from "@fengqiaogang/safe-get";

// @ts-ignore
import Config from "@/config";

export interface Storage {
  v: any;
}

interface Result {
  datetime: number;
  content: any;
}

export const remove = function (key: string): void {
  if (key !== "APP_LANG") {
    localStorage.removeItem(key);
  }
}

export const clear = function () {
  for (let i = 0; i < localStorage.length; i++) {
    const name = localStorage.key(i);
    if (name) {
      remove(name);
    }
  }
}

export const set = function (key: string, data: any, datetime: number = 0): void {
  //加密
  if (Config.LS_ENCRYPTION === "AES") {
    const tmp: Storage = {v: data};
    const value = JSON.stringify(tmp);
    data = AES.encrypt(value, Config.LS_ENCRYPTION_key);
  }
  const cacheValue: Result = {
    content: data,
    datetime: Number(datetime) === 0 ? 0 : new Date().getTime() + Number(datetime) * 1000
  }
  const text: string = JSON.stringify(cacheValue);
  localStorage.setItem(key, text);
}

export const get = function (key: string): any | undefined {
  let data: Result | undefined;
  const text = localStorage.getItem(key);
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (e) {
    }
  }
  if (data) {
    if (data.datetime && data.datetime > 0 && data.datetime < Date.now()) {
      remove(key);
      return void 0;
    }
    if (Config.LS_ENCRYPTION === "AES") {
      const value = AES.decrypt(data.content as string, Config.LS_ENCRYPTION_key);
      const tmp: Storage = JSON.parse(value);
      return tmp.v;
    }
    return data.content;
  }
  return void 0;
}

export const roleCheck = function (...roles): boolean {
  const info = get('USER_INFO');
  let list = _.concat([], safeGet<string[]>(info, "roles") || []);
  list = _.map(_.compact(list), _.toUpper);
  // 计算两个数组的交集
  const value = _.intersection(_.map(roles, _.toUpper), list);
  // 如果数据长度大于 0 表示通过
  return value.length > 0;
}

